module.exports = __webpack_public_path__ + "img/source_sw-con06.1dae5399.png";